module.exports = __webpack_public_path__ + "img/rank_empty.e8e80eb7.png";